module.exports = __webpack_public_path__ + "static/media/Forward_Primer.21bf2f18.svg";